const environment = process.env.REACT_APP_ENV || "local";

const config = {
  local: {
    baseAuthUrl: "https://localhost:7255/api/auth/",
    API_URL: "https://localhost:7255/api/chat",
    baseCustomerUrl: "https://localhost:7255/api/customers",

    baseFridgeUrl: "https://localhost:7255/api/fridge",
    getAllFridgesEndpoint: `https://localhost:7255/api/fridge/getallfridges`,
    setThresholdsEndpoint: `https://localhost:7255/api/fridge/SetThresholds`,
    getThresholdsEndpoint: `https://localhost:7255/api/fridge/GetThresholds`,
    updateThresholdsEndpoint: `https://localhost:7255/api/fridge/UpdateThresholds`,
    upsertThresholdsEndpoint: `https://localhost:7255/api/fridge/SetOrUpdateThresholds`,
    createOrderQueueEndpoint: `https://localhost:7255/api/fridge/createOrderQueueInitial`,
    toggleProductDisabledStatusEndpoint: `https://localhost:7255/api/fridge/ToggleProductDisabledStatus`,

    baseInventoryUrl: "https://localhost:7255/api/inventory",
    transferProductToFridgeEndpoint: `https://localhost:7255/api/inventory/transfertofridge`,

    baseWarehouseProductUrl: "https://localhost:7255/api/Inventory",
    baseKeyUrl: "https://localhost:7255/api/fridge/keys",
    baseCreateKeyUrl: "https://localhost:7255/api/fridge/create-key",
    swishPaidUrl: "https://localhost:7255/api/paymentrecords/paid",
    swishPaidAdminUrl: "https://localhost:7255/api/paymentrecords/paid-admin",

    baseProductUrl: "https://localhost:7255/api/product",
    createProductEndpoint: `https://localhost:7255/api/product/createproduct`,
    getAllCategoriesEndpoint: `https://localhost:7255/api/product/getallcategories`,
    getAllProductsEndpoint: `https://localhost:7255/api/product/getallproducts`,
    createCategoryEndpoint: `https://localhost:7255/api/product/create-category`,
    updateCategoryEndpoint: `https://localhost:7255/api/product/update-category`,
    deleteCategoryEndpoint: `https://localhost:7255/api/product/delete-category`,
    createTeamPlayerEndpoint: `https://localhost:7255/api/Product/create-teamplayer`,
    getAllTeamPlayersEndpoint: `https://localhost:7255/api/Product/GetAllTeamPlayers`,


    baseWarehouseUrl: "https://localhost:7255/api/warehouse",
    getAllWarehousesUrl:
      "https://localhost:7255/api/warehouse/getallwarehouses",
    getAllWarehousesByCustomerId: "https://localhost:7255/api/warehouse/getAllWarehousesByCustomerId",
    addProductsUrl: "https://localhost:7255/api/warehouse/addproduct",

    baseSettingsUrl: "https://localhost:7255/api/settings",

    overviewUrl: "https://localhost:7255/api/overview",
    baseStealingDetectionUrl: "https://localhost:7255/api/stealingdetection",
    baseAdminOverviewUrl: "https://localhost:7255/api/AdminOverview",

  },

  live: {
    baseAuthUrl: "https://boxmealadminapinew.azurewebsites.net/api/auth/",
    API_URL: "https://boxmealadminapinew.azurewebsites.net/api/chat",
    baseCustomerUrl:
      "https://boxmealadminapinew.azurewebsites.net/api/customers",

    baseFridgeUrl: "https://boxmealadminapinew.azurewebsites.net/api/fridge",
    getAllFridgesEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/fridge/getallfridges`,
    setThresholdsEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/fridge/SetThresholds`,
    getThresholdsEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/fridge/GetThresholds`,
    updateThresholdsEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/fridge/UpdateThresholds`,
    upsertThresholdsEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/fridge/SetOrUpdateThresholds`,
    createOrderQueueEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/fridge/createOrderQueueInitial`,
    toggleProductDisabledStatusEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/fridge/ToggleProductDisabledStatus`,

    baseInventoryUrl:
      "https://boxmealadminapinew.azurewebsites.net/api/inventory",
    transferProductToFridgeEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/inventory/transfertofridge`,

    baseWarehouseProductUrl:
      "https://boxmealadminapinew.azurewebsites.net/api/Inventory",

    baseKeyUrl: "https://boxmealadminapinew.azurewebsites.net/api/fridge/keys",
    baseCreateKeyUrl:
      "https://boxmealadminapinew.azurewebsites.net/api/fridge/create-key",
    swishPaidUrl:
      "https://boxmealadminapinew.azurewebsites.net/api/paymentrecords/paid",

    swishPaidAdminUrl:
      "https://boxmealadminapinew.azurewebsites.net/api/paymentrecords/paid-admin",

    baseProductUrl: "https://boxmealadminapinew.azurewebsites.net/api/product",
    createProductEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/product/createproduct`,
    getAllCategoriesEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/product/getallcategories`,
    getAllProductsEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/product/getallproducts`,
    createCategoryEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/product/create-category`,
    updateCategoryEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/product/update-category`,
    deleteCategoryEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/product/delete-category`,
    createTeamPlayerEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/Product/create-teamplayer`,
    getAllTeamPlayersEndpoint: `https://boxmealadminapinew.azurewebsites.net/api/Product/GetAllTeamPlayers`,

    baseWarehouseUrl:
      "https://boxmealadminapinew.azurewebsites.net/api/warehouse",

    baseSettingsUrl: "https://boxmealadminapinew.azurewebsites.net/api/settings",

    overviewUrl: "https://boxmealadminapinew.azurewebsites.net/api/overview",

    getAllWarehousesUrl:
      "https://boxmealadminapinew.azurewebsites.net/api/warehouse/getallwarehouses",
    getAllWarehousesByCustomerId: "https://boxmealadminapinew.azurewebsites.net/api/warehouse/getAllWarehousesByCustomerId",
    addProductsUrl:
      "https://boxmealadminapinew.azurewebsites.net/api/warehouse/addproduct",
    baseStealingDetectionUrl: "https://boxmealadminapinew.azurewebsites.net/api/stealingdetection",
    baseAdminOverviewUrl: "https://boxmealadminapinew.azurewebsites.net/api/AdminOverview",
  },
};

export default config[environment];
